import { Field } from '@/shared/api/rest/models';

export default function isFieldInsideBounds(field: Field, bounds: google.maps.LatLngBounds): boolean {
  return bounds.contains({ lng: field.lon, lat: field.lat }) || false;
}
